module.exports = __webpack_public_path__ + "static/media/mountain_biking_768.ec05ac7c.webp";